import { FC, memo } from "react";
import { Props } from "@/models";

export const AppListItem: FC<Props.AppListItems> = ({
  items,
  ItemComponent,
}) => {
  return (
    <>
      {items.map((item, i) => (
        <ItemComponent key={i} {...item} />
      ))}
    </>
  );
};

export const MemoizedAppListItem = memo(AppListItem);
